import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Box, Typography, Checkbox } from "@mui/material";

const CmLabel = (props) => {
    const { children, ...lProps } = props;
    return (
        <label style={{ color: '#6D7280', fontSize: '14px' }} {...lProps}>{children}</label>
    );
}

const Step2 = ({ extrasFood = [], initialFood = [], extrasCustom = [], initialCustom = [], persons = {}, onFoodChange = (..._args) => { }, onCustomChange = (..._args) => { }, modalOpen = false }) => {
    const { t } = useTranslation("checkout");
    const hasFoodExtras = Array.isArray(extrasFood) && extrasFood.length > 0;
    const [selectedFood, setSelectedFood] = useState(() => {
        if (!Array.isArray(initialFood)) return [];
        return initialFood.map(f => f.id ?? f.description ?? String(f));
    });
    const [selectedCustom, setSelectedCustom] = useState(() => {
        if (!Array.isArray(initialCustom)) return [];
        return initialCustom.map(c => c.name ?? String(c));
    });

    // Reapply initial selections when modal opens so UI matches parent's saved state
    useEffect(() => {
        if (!modalOpen) return;
        if (Array.isArray(initialFood) && initialFood.length > 0) {
            setSelectedFood(initialFood.map(f => f.id ?? f.description ?? String(f)));
        }
        if (Array.isArray(initialCustom) && initialCustom.length > 0) {
            setSelectedCustom(initialCustom.map(c => c.name ?? String(c)));
        }
    }, [modalOpen, initialFood, initialCustom]);

    return (
        <>
            <Typography
                variant="h5"
                sx={{
                    fontSize: '20px',
                    color: 'secondary.main'
                }}
            >
                {t('update-tour-step3-include-title')}
            </Typography>

            {!hasFoodExtras ? (
                <Box
                    sx={{
                        mt: 2,
                        p: 2,
                        borderRadius: 2,
                        border: '1px solid #E5E7EB',
                        background: 'linear-gradient(180deg, #F9FAFB 0%, #FFFFFF 100%)'
                    }}
                >
                    <Typography sx={{ fontSize: 13, color: '#6D7280', fontWeight: 500 }}>
                        {t('update-tour-no-food-extras')}
                    </Typography>
                </Box>
            ) : (
                <>
                    <Box sx={{
                        pb: '10px'
                    }}>
                        <Box>
                            <CmLabel htmlFor="complements">{t('update-tour-step3-food-question')}</CmLabel>
                        </Box>
                        <Box sx={{ mt: 1 }}>
                            {extrasFood.map(food => {
                                const key = food.id ?? food.name ?? String(food);
                                const checked = selectedFood.includes(key);
                                const price = Number(food.price || 0);
                                const paxCount = Object.values(persons).reduce((s, v) => s + (Number(v) || 0), 0) || 1;
                                return (
                                    <Box key={key} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1, border: '1px solid #eee', borderRadius: 1, mb: 1 }}>
                                        <Box>
                                            <Typography sx={{ fontSize: 13, color: 'secondary.main' }}>{food.name}</Typography>
                                            <Typography sx={{ fontSize: 12, color: 'secondary.main' }}>{price ? `$${price} x ${paxCount}` : t('update-tour-step3-free')}</Typography>
                                        </Box>
                                        <Checkbox
                                            checked={checked}
                                            onChange={() => {
                                                setSelectedFood(prev => {
                                                    const exists = prev.includes(key);
                                                    const next = exists ? prev.filter(p => p !== key) : [...prev, key];
                                                    const selectedObjs = extrasFood.filter(f => next.includes(f.id ?? f.description ?? String(f)));
                                                    onFoodChange(selectedObjs);
                                                    return next;
                                                });
                                            }}
                                        />
                                    </Box>
                                )
                            })}
                        </Box>
                    </Box>

                    <Box sx={{
                        pb: '10px'
                    }}>
                        <Box>
                            <CmLabel htmlFor="complements">
                                {t('update-tour-step3-other-extras')}
                            </CmLabel>
                        </Box>
                        {Array.isArray(extrasCustom) && extrasCustom.length > 0 && (
                            <Box sx={{ mt: 1 }}>
                                {extrasCustom.map(custom => {
                                    const key = custom.name ?? String(custom);
                                    const checked = selectedCustom.includes(key);
                                    const price = Number(custom.price || 0);
                                    const paxCount = Object.values(persons).reduce((s, v) => s + (Number(v) || 0), 0) || 1;
                                    return (
                                        <Box key={key} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1, border: '1px solid #eee', borderRadius: 1, mb: 1 }}>
                                            <Box>
                                                <Typography sx={{ fontSize: 13, color: 'secondary.main' }}>{custom.name}</Typography>
                                                <Typography sx={{ fontSize: 12, color: 'secondary.main' }}>{price ? `$${price} x ${paxCount}` : t('update-tour-step3-free')}</Typography>
                                            </Box>
                                            <Checkbox
                                                checked={checked}
                                                onChange={() => {
                                                    setSelectedCustom(prev => {
                                                        const exists = prev.includes(key);
                                                        const next = exists ? prev.filter(p => p !== key) : [...prev, key];
                                                        const selectedObjs = extrasCustom.filter(c => next.includes(c.name ?? String(c)));
                                                        onCustomChange(selectedObjs);
                                                        return next;
                                                    });
                                                }}
                                            />
                                        </Box>
                                    )
                                })}
                            </Box>
                        )}
                    </Box>
                </>
            )}
        </>
    )
}

export default Step2;
